import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { site } from '../../../data';

const fullTitle = (title) => `${title} - ${site.name}`;

const Title = ({ children }) => (
  <Helmet>
    <title>{fullTitle(children)}</title>
    <meta property="og:title" content={fullTitle(children)} />
    <meta name="twitter:title" content={fullTitle(children)} />
  </Helmet>
);

Title.propTypes = {
  children: PropTypes.string.isRequired,
};

export default Title;



// WEBPACK FOOTER //
// ./src/app/components/seo/title/index.js